import { render, staticRenderFns } from "./ShareBar.vue?vue&type=template&id=045c99a6&scoped=true"
import script from "./ShareBar.vue?vue&type=script&lang=js"
export * from "./ShareBar.vue?vue&type=script&lang=js"
import style0 from "./ShareBar.vue?vue&type=style&index=0&id=045c99a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c99a6",
  null
  
)

export default component.exports